import React from "react";

import { Card, Stack } from '@material-ui/core';
import AppPage from "../../components/AppFrame/AppPage";
import { RouteComponentProps } from "@reach/router";
import SupportChatList from "./SupportChatList";
import SupportMessages from "./SupportMessages";
import MessageInputBox from "./MessageInputBox";
import SupportChatHeader from "./SupportChatHeader";



const Support: React.FC<RouteComponentProps> = () => {


  return (
    <AppPage title="Support">
      <Stack direction="row" spacing={2} sx={{ flex: 1 }}>
        <Card variant="outlined" sx={{ minWidth: 250 }}>
          <SupportChatList />
        </Card>
        <Card variant="outlined" sx={{ flex: 1, p: 1 }}>
          <Stack direction="column" spacing={1} sx={{ height: '100%' }}>
            <SupportChatHeader />
            <SupportMessages />
            <MessageInputBox />
          </Stack>
        </Card>
      </Stack>
    </AppPage>
  );
};

export default Support;